import { render, staticRenderFns } from "./new_accepting_order_fields.vue?vue&type=template&id=0d63e201&lang=pug&"
import script from "./new_accepting_order_fields.vue?vue&type=script&lang=js&"
export * from "./new_accepting_order_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports